export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || 'REACT_APP_CLIENT_ID_TO_REPLACE'
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'REACT_APP_TENANT_ID_TO_REPLACE'
export const TOKEN_SCOPE = process.env.REACT_APP_TOKEN_SCOPE || 'REACT_APP_TOKEN_SCOPE_TO_REPLACE'
